module.exports = __webpack_public_path__ + "static/media/ContasPagRec5.2bae8a0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/RelContasPagRec/ContasPagRec5.png
// module id = 2014
// module chunks = 0